import BEMHelper from 'react-bem-helper';

export const bem = BEMHelper({ name: 'NewPlanDay', outputIsString: true });
